import { createContext } from "react";

export const PrintContext = createContext([]);
